'use client';

import { VideoRecommendationsComponent } from './VideoRecommendationsComponent';

export function VideoRecommendationsComponentC(
  props: React.ComponentProps<typeof VideoRecommendationsComponent>,
) {
  return <VideoRecommendationsComponent {...props} />;
}
